import React from 'react';
import { EmailShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';

const ShareBox = (props) => {
    let share = 'Share';
    let displayFacebook = true;
    if (props.lang == 'ru-RU') {
        share = 'Поделиться';
        displayFacebook = false
    }

    return (
        <div className="share-box">
            <span>{share}:</span>
            {displayFacebook ?  <FacebookShareButton  url={location.href} className="fb"></FacebookShareButton>: null}
            <TwitterShareButton url={location.href} title={props.MetaPageTitle} className="twitter"></TwitterShareButton>
            <EmailShareButton url={location.href} title={props.MetaPageTitle} body={props.MetaPageDescription} className="email"></EmailShareButton>
        </div>
    );
}
export default ShareBox;
